// ---------------------------------------
// GadgetLoad.js
// Presun na cast stránky s animáciou po klinuti na ID
// ---------------------------------------

const GadgetLoad = {
    Init: function () {        
        $('#gadget').click(function() {
            $('html, body').animate({ scrollTop: 0 }, 500); 
        });       
    }
};

window.GadgetLoad = GadgetLoad;
export default GadgetLoad;
